/* eslint-disable @intlify/vue-i18n/no-dynamic-keys */
import { useI18n } from 'vue-i18n';

export function useAutomationLocales() {
  const { t } = useI18n();

  const toLocale = (key, defaultFallback) => {
    if (!key) return defaultFallback;

    const translationKey = `WGPT_AUTOMATIONS.REGISTRY.${key}`;
    const translation = t(translationKey, undefined, {
      missingWarn: false,
    });

    if (translation === translationKey) return defaultFallback;

    return translation;
  };

  return {
    toLocale,
  };
}
